/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';

@Injectable({
  providedIn: 'root',
})
export class TutorialResourceService {
  private readonly url: string = "";

  constructor(private readonly httpClient: HttpClient, private readonly environmentService: EnvironmentService) {
    if (this.environmentService && this.environmentService.getEnvironmentProperty('tutorialUrl')) {
      this.url = `${this.environmentService.getEnvironmentProperty('tutorialUrl')}`;
    }
  }

  getTutorial(key: string) {
    return this.httpClient.get(`${this.url}/${key}`);
  }

  saveTutorial(tutorial: unknown) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    return this.httpClient.post(this.url, JSON.stringify(tutorial), { headers: headers });
  }
}
